"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ValidationResultFactory = exports.ValidationFactory = void 0;
exports.ValidationFactory = {
    createInstance: function (params) {
        var defaultParams = {
            valid: true,
            errors: new Array(),
            warnings: new Array(),
            fields: {}
        };
        var _a = __assign(__assign({}, defaultParams), params), errors = _a.errors, fields = _a.fields, valid = _a.valid, warnings = _a.warnings;
        return {
            errors: errors,
            fields: fields,
            valid: valid,
            warnings: warnings
        };
    }
};
exports.ValidationResultFactory = {
    createInstance: function (params) {
        if (params === void 0) { params = {}; }
        var defaultParams = {
            valid: true
        };
        var _a = __assign(__assign({}, defaultParams), params), severity = _a.severity, messageKey = _a.messageKey, messageParams = _a.messageParams, customMessages = _a.customMessages, valid = _a.valid;
        return {
            severity: severity,
            messageKey: messageKey,
            messageParams: messageParams,
            customMessages: customMessages,
            valid: valid
        };
    }
};
//# sourceMappingURL=factory.js.map